<!--Cancel button-->
<a
  id="requestCancelBooking"
  *ngIf="booking.status === 'CONFIRMED'"
  type="button"
  (click)="showCancelBooking()"
  class="cancel-btn href"
>
  {{ 'CANCEL_BOOKING' | translate }}
</a>

<!--Cancel booking modal-->
<div
  *ngIf="booking"
  class="modal fade"
  [class.modal-ios]="ios"
  bsModal
  #cancelBookingModal="bs-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-fullscreen-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">
          {{ 'HELP_US_IMPROVE' | translate }}
          <div class="modal-subtitle">{{ 'WHY_ARE_YOU_CANCELING' | translate }}</div>
        </h4>
        <button
          id="closeCancelBookingModal"
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="cancelBookingModal.hide()"
        >
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <lh-shared-ui-spinner *ngIf="isLoading"></lh-shared-ui-spinner>
        <div *ngFor="let reason of cancelReasons" class="form-group">
          <label [hidden]="reason.hidden && !reasonsExpanded" for="enum_answer_{{ reason.key | lowercase }}">
            <input
              id="enum_answer_{{ reason.key | lowercase }}"
              class="reason-radio-input"
              type="radio"
              name="mode"
              [value]="reason.key"
              [(ngModel)]="cancelReasonCode"
            />
            {{ reason.value }}
          </label>
        </div>
        <div class="form-group">
          <p class="text-center">
            <a id="expandCancelReasons" *ngIf="!reasonsExpanded" class="href" (click)="reasonsExpanded = true">
              {{ 'MORE_REASONS' | translate }}
            </a>
          </p>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            type="text"
            autocomplete="off"
            rows="5"
            maxlength="5000"
            style="overflow: auto; resize: none"
            [(ngModel)]="cancelReason"
            [placeholder]="'COMMENTS' | translate"
          >
          </textarea>
        </div>
      </div>

      <div class="modal-footer">
        <div>
          <button
            id="abortCancelBooking"
            type="button"
            class="btn btn-info"
            (click)="cancelBookingModal.hide()"
            [disabled]="isLoading"
            tabindex="-1"
          >
            {{ 'ABORT_CANCEL_BOOKING' | translate }}
          </button>
          <button
            id="confirmCancelBooking"
            type="button"
            class="btn btn-primary"
            (click)="cancelBooking()"
            [disabled]="!isCancelAllowed"
          >
            {{ 'CONFIRM_CANCEL_BOOKING' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
